<template>
    <div class="px-8px py-12px px-md-10px py-md-16px">
        <v-row align="center" class="row--small">
            <v-col cols="auto">
                <div class="pr-10px">
                    <div class="border mx-auto">
                        <v-img :src="needUrl ? setImgSrc(cart.product.thumb) : cart.product.thumb" width="120" :aspect-ratio="1/1" contain/>
                    </div>
                </div>
            </v-col>
            <v-col>
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <v-row no-gutters align="center">
                            <v-col cols="12">
                                <div class="font-size-16 font-weight-medium">{{ cart.product.name }}</div>
                            </v-col>
                            <v-col v-if="cart.product.type == 'option'" cols="12">
                                <div class="font-size-14 font-size-md-16">[{{ cart.product.optionalNames.toString() }}] : {{ cart.product.optionalValues.toString() }}</div>
                            </v-col>
                            <v-col cols="12">
                                <div class="d-inline-flex align-center font-size-18 font-size-md-24">
                                    <b class="primary--text">{{ parseInt(cart.product.salePrice * cart.quantity).format() }}</b><span class="font-size-16 ml-2px">원</span>
                                </div>
                                <!-- <div class="font-size-14 mt-2">
                                    <v-icon size="18" class="mr-1">mdi-truck-delivery</v-icon>
                                    <template v-if="cart.product.shippingCode == 'later' && !cart.product.shippingPrice">착불배송</template>
                                    <template v-if="cart.product.shippingPrice && cart.product.shippingCode == 'self'">배송비 {{ cart.product.shippingPrice.format() }} 원</template>
                                    <template v-if="!cart.product.shippingPrice && cart.product.shippingCode == 'free'">무료배송</template>
                                    <template v-if="cart.product.shippingCode == 'order'">배송비 {{ setting.shippingPrice.lt.format() }} 원</template>
                                </div> -->
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer/>
                    <v-col cols="12" md="auto">
                        <div class="mt-6px mt-md-0px">
                            <strong class="font-size-14 font-size-md-16 font-weight-medium">구매수량 : {{ cart.quantity }}</strong>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mdiTruckDelivery } from "@mdi/js";
import api from "@/api";
export default {
    props: {
        value: { type: Array, default: () => [] },
        cart: { type: Object, default: () => ({}) },
        needUrl: { type: Boolean, default: false },
    },

    data(){
        return {
            mdiTruckDelivery,

            selected: this.$props.value || [],

            setting: null
        }
    },
    async mounted(){
        await this.init()
    },
    methods: {
        async init(){
            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;
        },
        setImgSrc(src) {
            // return `http://dev-giftcard.uxi.kr/${src}`;
            // return `https://dev-giftcard.uxi.kr/${src}`;
            return `https://daehanbooksgiftcard.com/${src}`;
        },
    }

}
</script>

<style scoped>
</style>